import React from 'react'
import SubNavbar from '../components/SubNavbar'
import Navbar from '../components/Navbar'
import { CartProvider, useCart } from 'react-use-cart';

function Cart() {
    const {isEmpty,totalUniqueItems,items,updateItemQuantity,removeItem,cartTotal} =
     useCart();
    if (isEmpty) {
  
      return (
        <h2 className='text-center'>Your cart is empty</h2>
      )
    }
  
    return (
      <div>
        <main class="page">
           <section class="shopping-cart dark">
               <div class="container">
                  <div class="block-heading">
                    <h2>Shopping Cart ({totalUniqueItems})</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc quam urna, dignissim nec auctor in, mattis vitae leo.</p>
                  </div>
                  <div class="content">
                       <div class="row">
                           <div class="col-md-12 col-lg-8">
                               <div class="items">
                  {items.map( (item)=>(
                                   <div class="product">
                                       <div class="row">
                                           <div class="col-md-3">
                                               <img class="img-fluid mx-auto d-block image" src={item.images[0]}/>
                                           </div>
                                           <div class="col-md-8">
                                               <div class="info">
                                                   <div class="row">
                                                       <div class="col-md-5 product-name">
                                                           <div class="product-name">
                                                               <a href="#">{item.title}</a>
                                                               <div class="product-info">
                                                                   <div>Rating: <span class="value">{item.rating}</span></div>
                                                                   <div>Stock: <span class="value">{item.stock}</span></div>
                                                               </div>
                                                           </div>
                                                       </div>
                                                       <div class="col-md-4 quantity">
                                                           <label for="quantity">Quantity:</label>
                                                           <br/>
                              {item.quantity}
                              <br/>
                              <button className='btn btn-success' onClick={()=>updateItemQuantity(item.id,item.quantity-1)}>-</button>
                              <button className='btn btn-dark mx-3' onClick={()=>updateItemQuantity(item.id,item.quantity+1)}>+</button>
                              <button onClick={()=>removeItem(item.id)} className='btn btn-danger'>&times;</button>
                                                       </div>
                                                       <div class="col-md-3 price">
                                                           <span>${Math.ceil(item.price*item.quantity)}</span>
                                                       </div>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                   </div>
                  ))}
                               </div>
                           </div>
                           <div class="col-md-12 col-lg-4">
                               <div class="summary">
                                   <h3>Summary</h3>
                                   <div class="summary-item"><span class="text">Subtotal</span><span class="price">${Math.ceil(cartTotal)}</span></div>
                                   <div class="summary-item"><span class="text">Discount</span><span class="price">$0</span></div>
                                   <div class="summary-item"><span class="text">Shipping</span><span class="price">$30</span></div>
                                   <div class="summary-item"><span class="text">Total</span><span class="price">${Math.ceil(cartTotal+30)}</span></div>
                                   <button type="button" class="btn btn-primary btn-lg btn-block">Checkout</button>
                               </div>
                           </div>
                       </div> 
                   </div>
               </div>
          </section>
      </main>
      </div>
    );
  }
function AllCart() {
  return (
    <CartProvider>
        <SubNavbar/>
        <Navbar/>
        <Cart/>
    </CartProvider>
  )
}

export default AllCart